<template>
     <b-container fluid class="d-flex flex-column mh-100 h-100">
        <b-row class="w-100 h-100">
            <b-col cols="2">
                <b-row v-for="subField in this.subClassFieldSet" :key="subField.name">
                    <b-col>
                        <div class="w-75 mx-auto my-2 text-center py-2 bg-gray rounded"
                            :draggable="true"
                            @dragstart="startDrag($event, subField)"
                            @dragover.stop
                            @dragenter.prevent
                            @dragend="endDrag"
                            style="cursor: grab;">
                            {{ subField.name }}
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="Report?.ReportParameters != null && Report.ReportParameters.FieldSets.filter(u => !u.equalsFieldSet()).length > 0" v-for="subParam in this.subClassParameter" :key="subParam.name">
                    <b-col>
                        <div class="w-75 mx-auto my-2 text-center py-2 bg-gray rounded"
                            :draggable="true"
                            @dragstart="startDrag($event, subParam)"
                            @dragover.stop
                            @dragenter.prevent
                            @dragend="endDrag"
                            style="cursor: grab;">
                            {{ subParam.name }}
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <!-- <b-col @dragover="cancelDrop"> -->
            <b-col>
                <b-card v-if="this.Report != undefined" class="p-2 w-100 border"
                    body-class="d-flex flex-column align-self-center w-100 p-0 my-0 rounded shadow-sm">
                    <ReportParameter 
                        ref="ReportParameter"
                        :ReportParameters="Report.ReportParameters"
                        :FunctionRegistry="functionRegistry"
                        :IsEditor="true"
                        @drop="handleDrop"
                        @openParameterModal="openParameterModal"
                        @dragover="$event.preventDefault()" />
                </b-card>
            </b-col>
        </b-row>

        <b-modal id="modal" size="lg" v-model="openModal" no-close-on-backdrop no-close-on-esc hide-footer>
            <template #modal-header>
                <div class="h-100 w-100">
                    <!-- @Todo: translate-->
                    <h5 class="modal-title text-center w-100" style="font-weight: bold;">{{ selectedFunction.Type }}</h5> 
                </div>
            </template>
            <template #default>
                <ParametersModal :Parameter="selectedFunction" :Variant="Variant" />
            </template>
            
        </b-modal>
    </b-container>

     <!-- <template #modal-footer>
                <div class="w-100">
                    <b-button class="float-right rounded-pill btn-outline-white bg-secondary btnIcon m-1 py-1 px-3" size="sm" variant="secondary" style="height: 2rem;"
                            @click="addObject()">
                        Appliquer
                    </b-button>
                    <b-button class="float-right rounded-pill btn-outline-secondary bg-white btnIcon m-1 py-1 px-3" size="sm" variant="outline-secondary" style="border-radius: 5px; height: 2rem;" 
                            @click="cancelObject()">
                        Annuler
                    </b-button>
                </div>
            </template> -->
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import Dictionary from "@/types/Dictionary";
import axios from "axios";
import { API_URL } from "@/App.settings";
import Report from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/Report";
import ReportParameter from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/ReportParameter.vue";
import ParametersModal from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/ParametersModal.vue";
import FieldSet from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/FieldSet";
import Parameter from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/Parameter";

@Component({
		components: {
            ReportParameter,
            ParametersModal
		}
	})
export default class DesignerParameter extends Vue {
    @Prop({default: () => "secondary"})
    public Variant!: string;

    @Prop({default: () => new Report()})
    public Report: Report;

    private xmlContent: string = 
    `<Root>
        <Parameters>
        </Parameters>
        <FieldSet Title="Période : période de fin" Layout="Column" Type="Client">
            <Parameter Name="FirstYear" Label="Année Début" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
            <Parameter Name="LastYear" Label="Année Fin" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
        </FieldSet>
        <FieldSet Title="Période : période du début" Layout="Column" Type="Client">
            <Parameter Name="FirstYear" Label="Année Début" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
        </FieldSet>
        <FieldSet Title="Correction DJU" Layout="Column" Type="Client">
            <Parameter Name="FirstYear" Label="Année Début" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
        </FieldSet>
    </Root>`;

    // private report: Report = new Report();

    // Récupère toutes les sous-classes de Parameter
    private subClassParameter: typeof Parameter[] = Parameter.getSubclasses();
    // Récupère toutes les sous-classes de FieldSet (Pour l'instant juste la class FieldSet)
    private subClassFieldSet: typeof FieldSet[] = FieldSet.getSubclasses();

    private openModal: boolean = false;
    private functionRegistry: Map<string, Function> = new Map<string, Function>();
    private selectedFunction: any = [];
    
    //#region Drag

    /**
     * 
     * @param evt 
     * @param option Fonction séléctionnée
     */
     private startDrag(evt, option: Function) {
        evt.dataTransfer.dropEffect = 'move';
        evt.dataTransfer.effectAllowed = 'move';
        evt.dataTransfer.setData('targetDrag', option.name);

        // Ajoute la fonction au dictionnaire
        this.functionRegistry.set(option.name, option);

        // Créer des objets temporaire selon le composant séléctionné
        option.prototype.createGhost(this.Report.ReportParameters);

        // Remet les compteurs à 0 (-1)
        (this.$refs.ReportParameter as ReportParameter).selectedFieldSetIndex = -1;
        (this.$refs.ReportParameter as ReportParameter).selectedParameterIndex = -1;
    }

    /**
     * 
     * @param event 
     * @param target 
     */
    private handleDrop(event, target: string) {
        let targetDrag: Function = this.functionRegistry.get(event.dataTransfer.getData('targetDrag'));
        let targetDragName: string = targetDrag.prototype.getClassName();
        // Si la cible est différente de l'objet demandé
        if(target != targetDragName){
            event.stopPropagation();
        }
        else{
            this.selectedFunction = Reflect.construct(targetDrag, ['']);
            this.openModal = true;
        }

        event.preventDefault();
    };


    private openParameterModal(object: FieldSet | Parameter){
        this.selectedFunction = object.create();
        this.openModal = true;
    }

    /**
     * Action quand la cible n'est pas la bonne
     * @param event 
     */
    private endDrag(event){
        // Si la modal n'est pas ouverte c'est que la cible n'est pas la bonne
        if(!this.openModal){
            let targetDrag: Function = this.functionRegistry.get(event.dataTransfer.getData('targetDrag'));
            targetDrag.prototype.deleteGhost(this.Report.ReportParameters);
        }
    }

    //#endregion

    //#region Object

    private addObject(){
        this.selectedFunction.save(this.Report.ReportParameters, (this.$refs.ReportParameter as ReportParameter).selectedFieldSetIndex, (this.$refs.ReportParameter as ReportParameter).selectedParameterIndex); 
        this.openModal = false;
    }

    private cancelObject(){
        this.selectedFunction.deleteGhost(this.Report.ReportParameters);
        this.openModal = false
    }

    //#endregion

    /**
     * Sauvegarde ReportParameters
     */
    public async save() {

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["ReportParameters"] = this.Report?.ReportParameters;

        await axios.post(API_URL + "ReportExploitation/SaveReportParameters", args).then((response) => {
            
        });
    }
}

</script>

<style scoped>
    .editor-container {
        border: 1px solid #ddd;
        border-radius: 5px;
        height: 100%;
        overflow: hidden;
    }
</style>